import React from "react";
import "./Footer.css";
import logo from "../assets/nuts-spices-logo.png";

const Footer = () => {
  return (
    <footer className="it-footer">
      <div className="it-footer__container">
        {/* Top: Columns */}
        <div className="it-footer__grid">
          {/* Brand + About */}
          <div className="it-footer__brand">
            <a href="/" className="it-footer__logo-link">
              <img src={logo} alt="Holland Tahini Logo" className="it-footer__logo" />
            </a>
            <p className="it-footer__about">
              Bringing the authentic, nutty flavor of sesame to your table with premium tahini made in the Netherlands.
            </p>
          </div>

          {/* Legal */}
          <div className="it-footer__col">
            <h3>LEGAL</h3>
            <ul>
              <li><a href="/policies/privacy-policy">Privacy Policy</a></li>
              <li><a href="/policies/terms-of-service">Terms of Service</a></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="it-footer__col">
            <h3>CUSTOMER SERVICE</h3>
            <ul>
              <li><a href="/pages/contact">Contact Us</a></li>
              <li><a href="/pages/faq">FAQ</a></li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="it-footer__col">
            <h3>FOLLOW US</h3>
            <ul className="it-footer__socials">
              <li><a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a></li>
              <li><a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="it-footer__bottom">
          <p>
            © {new Date().getFullYear()} Holland Tahini.  
            <span className="it-footer__subtext">
              &nbsp;Part of <strong>Nuts and Spices Bazaar B.V Group</strong>
            </span>
          </p>
          <p>
            Website Developed with 💛 by{" "}
            <a
              href="https://stepup-analytics.com"
              target="_blank"
              rel="noreferrer"
            >
              StepUp Analytics
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
